import React from "react";
import "./DisclaimerBox.css";

class DisclaimerBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closedDiclaimer: localStorage.getItem("closedDisclaimer") || null
    };
  }
  handleClose(e) {
    e.preventDefault();
    this.setState({ closedDiclaimer: "true" });
    localStorage.setItem("closedDisclaimer", "true");
  }
  render() {
    let isChrome = window.navigator.userAgent.indexOf("Chrome") !== -1;
    return (
      <React.Fragment>
        {!isChrome && (
          <aside
            className={`DisclaimerBox ${
              this.state.closedDiclaimer === "true" ? "hide" : "display"
            }`}
          >
            <p className={`DisclaimerBox__para`}>
              This experience runs better on modern browsers. For the best
              experience use Chrome.
            </p>
            <button
              className="DisclaimerBox__button--close"
              onClick={e => this.handleClose(e)}
            >
              Close
            </button>
          </aside>
        )}
      </React.Fragment>
    );
  }
}

export default DisclaimerBox;
